import config from '../config';
import jwt from 'jsonwebtoken';

/**
 * Cek apakah user punya token valid (ada dan belum kadaluarsa).
 * @returns {boolean}
 */
const hasToken = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;
  if (!config.isBackend && token) return true;
  const date = new Date().getTime() / 1000;
  const data = jwt.decode(token);
  if (!data || !data.exp) return false;
  return date < data.exp;
};

export default hasToken;
